












import Vue from "vue"
import CProfileSearchList from "~/components/custom/profileList/CProfileSearchList.vue"
import PSubscriptionGuidanceForScoutModal from "~/components/custom/scout/PSubscriptionGuidanceForScoutModal.vue"
import { ParticularWriteAcl } from "~/config/acl/accessControlList"
import { BackendApi } from "~/backendApis"

export default Vue.extend({
  components: {
    CProfileSearchList,
    PSubscriptionGuidanceForScoutModal,
  },
  layout: "application",
  scrollToTop: false,
  data() {
    return {
      isVisibleSubscriptionGuidanceModal: false,
      isVisibleScoutThanksModal: false,
    }
  },
  head() {
    return this.$clHelpers.metaTag.generate({
      title: "ユーザー一覧",
      currentPath: this.$nuxt.$route.path,
    })
  },
  computed: {
    // ユーザーをスカウトする権限があるかを判定
    hasPermissionToScoutUser(): boolean {
      return this.$clAuth.hasPermission(ParticularWriteAcl.USER_SCOUT)
    },
  },
  created() {
    this.$clStores.mobileNavigationMenu.actions.changeState({
      pageTitle: "ユーザー",
      isVisibleBottomNav: true,
    })
  },
  methods: {
    navigateToProjectSearchListPage() {
      this.$nuxt.$router.push({
        path: "/profiles",
      })
    },
    openSubscriptionGuidanceModal() {
      this.isVisibleSubscriptionGuidanceModal = true
    },
    closeSubscriptionGuidanceModal() {
      this.isVisibleSubscriptionGuidanceModal = false
    },
    async fetchScoutDetailLatest(params: {
      universalUid: string
      universalCorporationId: string
    }): Promise<string | undefined> {
      const scout = await new BackendApi.CorporationMember.Matching.GetScoutDetailLatestReadRequest(
        {
          universalUid: params.universalUid,
          universalCorporationId: params.universalCorporationId,
        }
      ).get()
      return scout?.chatGroupId
    },
    async openScoutPageIfQualified(universalUid: string) {
      if (!this.$clAuth.corporationId) {
        alert("企業アカウントに切り替えてからスカウトしてください。")
        return
      }

      // スカウトする権限がない場合に有料化モーダルを表示
      if (!this.hasPermissionToScoutUser) {
        this.openSubscriptionGuidanceModal()
        return
      }

      const chatGroupId = await this.fetchScoutDetailLatest({
        universalUid,
        universalCorporationId: this.$clAuth.corporationId,
      })

      // 相手とのスカウトが存在する場合はそのチャットグループの詳細ページに遷移
      if (chatGroupId !== undefined) {
        this.$nuxt.$router.push({
          path: `/corporation/chats/${chatGroupId}`,
        })
        return
      }

      // スカウト件数が制限範囲内か判定
      const limitCount = this.$clAuth.limitCount(ParticularWriteAcl.USER_SCOUT)
      const scoutCount = await this.countScouts()
      if (limitCount && limitCount <= scoutCount) {
        // 制限を超えていた場合、有料プランへ誘導
        this.openSubscriptionGuidanceModal()
        return
      }

      // 相手とのスカウトがない場合は、スカウト作成ページへ遷移
      this.$nuxt.$router.push({
        path: `/corporation/scouts/create/${universalUid}`,
      })
    },
    async countScouts(daysOfAggregationPeriod?: number): Promise<number> {
      return (
        await BackendApi.CorporationMember.Matching.read.countScouts({
          universalCorporationId: this.$clAuth.corporationIdOrFail,
          daysOfAggregationPeriod,
        })
      ).numberOfScouts
    },
  },
})
